import React from "react";
import styled from "styled-components";
import businessManagement from "../../../assets/images/plmimplementationimage/ECAD.jpg";

const ECADIntegrationOverview = () => {
  return (
    <AboutSectionWrapper>
      <Container className="container">
        <Row>
          {/* Content Column */}
          <ContentColumn>
            <InnerColumn>
              <SecTitle>
                <Title>About Us</Title>
                <Heading>Overview</Heading>
              </SecTitle>
              <Text>
                NexTech implements Teamcenter’s integration for Mechatronics to
                address cross-domain design &amp; process management challenges
                and achieve true system engineering. This we enable by
                integrating and implementing software (like Clear Case),
                electronics (like Mentor, Cadence), wire harness (like Mentor
                Capital Harness, Mentor, Ve-Sys, Zuken E3. series), and
                modelling tool (like MATLAB, Simulink) lifecycle. We ensure the
                best practice in electronic component BOM management, defining
                dependencies between electronic control units and software
                (source code), establishing relations between functions,
                requirements, logical design and networks, and product
                configuration &amp; visualization of data etc. This seamless
                integration enables designers in different domains to capture,
                control shared, and manage mechanical, electronics, and software
                design data in a single highly secured collaborative environment
                and brings you several benefits
              </Text>
            </InnerColumn>
          </ContentColumn>
          {/* Image Column */}
          <ImageColumn>
            <ImageInnerColumn data-wow-delay="0ms" data-wow-duration="1500ms">
              <ImageWrapper>
                <Image
                  src={businessManagement}
                  alt="Business Process And Change Management"
                />
                <ImageOverlayBox></ImageOverlayBox>
              </ImageWrapper>
            </ImageInnerColumn>
          </ImageColumn>
        </Row>
      </Container>
    </AboutSectionWrapper>
  );
};

export default ECADIntegrationOverview;

const AboutSectionWrapper = styled.section`
  position: relative;
  padding: 20px 0px 0px 0px;
  font-family: "Poppins", system-ui;
`;

const Container = styled.div`
  .container;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ContentColumn = styled.div`
  flex: 1;
  position: relative;
  margin-bottom: 10px;
  @media (max-width: 992px) {
    padding-right: 0;
  }
`;

const InnerColumn = styled.div`
  position: relative;
  padding-top: 50px;
`;

const SecTitle = styled.div`
  position: relative;
  padding-bottom: 40px;
`;

const Title = styled.div`
  position: relative;
  color: #d7a449;
  font-size: 18px;
  font-weight: 700;
  padding-right: 50px;
  margin-bottom: 15px;
  display: inline-block;
  text-transform: capitalize;

  &:before {
    position: absolute;
    content: "";
    right: 0px;
    bottom: 7px;
    width: 40px;
    height: 1px;
    background-color: #bbbbbb;
  }
`;

const Heading = styled.h2`
   font-family: "Poppins", system-ui;
  font-weight: 500;
  font-size: 2em;
  color: #06334b;
`;

const Text = styled.div`
  position: relative;
  color: #777777;
   font-size: 1em;
  line-height: 2em;
  margin-bottom: 40px;
  font-weight: 400;
  text-align: justify;
`;

const ImageColumn = styled.div`
  flex: 1;
  position: relative;
  margin-bottom: 50px;
`;

const ImageInnerColumn = styled.div`
  position: relative;
  padding: 40px 40px 0px 0px;
  margin-left: 50px;

  &:after {
    position: absolute;
    content: "";
    right: 27px;
    top: 5px;
    left: 40px;
    bottom: 64px;
    z-index: -1;
    border: 2px solid #d7a449;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
`;

const ImageOverlayBox = styled.div`
  position: absolute;
  left: 40px;
  bottom: 48px;
`;

const Image = styled.img`
  position: relative;
  width: 90%; /* Adjust the width as needed */
  display: block;
  margin: 0 auto; /* Center the image */
`;
